// Local-timezone date helpers. Never use toISOString() for calendar dates —
// it returns UTC and shifts the day for IST users before 05:30.

export function localISO(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function todayISO() {
  return localISO();
}

export function addDaysISO(days) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return localISO(d);
}

export function endOfThisWeekISO() {
  const d = new Date();
  const dow = d.getDay(); // 0=Sun..6=Sat
  let diffToFri = ((5 - dow) + 7) % 7;
  if (diffToFri === 0) diffToFri = 7; // On a Friday, aim for next Friday so the card stays in "This week"
  d.setDate(d.getDate() + diffToFri);
  return localISO(d);
}
